/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Filmstrip_Frame_Count_HelpInputs */

const en_options_editor_filmstrip_frame_count_help = /** @type {(inputs: Options_Editor_Filmstrip_Frame_Count_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of frames to generate before and after the selected event start time (1-30). A value of 12 generates 25 thumbnails total.`)
};

const fr_options_editor_filmstrip_frame_count_help = /** @type {(inputs: Options_Editor_Filmstrip_Frame_Count_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre d'images à générer avant et après l'heure de début de l'événement sélectionné (1 à 30). Une valeur de 12 génère 25 vignettes au total.`)
};

const de_options_editor_filmstrip_frame_count_help = /** @type {(inputs: Options_Editor_Filmstrip_Frame_Count_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Frames, die vor und nach dem ausgewählten Ereignisstart generiert werden sollen (1–30). Ein Wert von 12 erzeugt insgesamt 25 Thumbnails.`)
};

const it_options_editor_filmstrip_frame_count_help = /** @type {(inputs: Options_Editor_Filmstrip_Frame_Count_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di fotogrammi da generare prima e dopo l'ora di inizio dell'evento selezionato (1-30). Un valore di 12 genera un totale di 25 miniature.`)
};

const ru_options_editor_filmstrip_frame_count_help = /** @type {(inputs: Options_Editor_Filmstrip_Frame_Count_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество кадров, которые необходимо сгенерировать до и после выбранного времени начала события (1-30). Значение 12 генерирует в общей сложности 25 миниатюр.`)
};

const es_options_editor_filmstrip_frame_count_help = /** @type {(inputs: Options_Editor_Filmstrip_Frame_Count_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de fotogramas que se generarán antes y después de la hora de inicio del evento seleccionado (1-30). Un valor de 12 genera un total de 25 miniaturas.`)
};

const zh_cn2_options_editor_filmstrip_frame_count_help = /** @type {(inputs: Options_Editor_Filmstrip_Frame_Count_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在选定事件开始时间前后生成的帧数（1-30）。例如，值为 12 时，总共生成 25 张缩略图。`)
};

const ja_options_editor_filmstrip_frame_count_help = /** @type {(inputs: Options_Editor_Filmstrip_Frame_Count_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベント開始時刻の前後で生成するフレーム数（1～30）。値12を指定すると、合計25枚のサムネイルが生成されます。`)
};

const hi_options_editor_filmstrip_frame_count_help = /** @type {(inputs: Options_Editor_Filmstrip_Frame_Count_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट के प्रारंभ समय से पहले और बाद में उत्पन्न होने वाले फ़्रेमों की संख्या (1-30)। 12 का मान कुल 25 थंबनेल उत्पन्न करता है।`)
};

const pt_pt2_options_editor_filmstrip_frame_count_help = /** @type {(inputs: Options_Editor_Filmstrip_Frame_Count_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de frames a serem gerados antes e depois do horário de início do evento selecionado (1-30). Um valor de 12 gera um total de 25 miniaturas.`)
};

/**
* | output |
* | --- |
* | "Number of frames to generate before and after the selected event start time (1-30). A value of 12 generates 25 thumbnails total." |
*
* @param {Options_Editor_Filmstrip_Frame_Count_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_filmstrip_frame_count_help = /** @type {((inputs?: Options_Editor_Filmstrip_Frame_Count_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Filmstrip_Frame_Count_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_filmstrip_frame_count_help(inputs)
	if (locale === "de") return de_options_editor_filmstrip_frame_count_help(inputs)
	if (locale === "it") return it_options_editor_filmstrip_frame_count_help(inputs)
	if (locale === "ru") return ru_options_editor_filmstrip_frame_count_help(inputs)
	if (locale === "es") return es_options_editor_filmstrip_frame_count_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_filmstrip_frame_count_help(inputs)
	if (locale === "ja") return ja_options_editor_filmstrip_frame_count_help(inputs)
	if (locale === "hi") return hi_options_editor_filmstrip_frame_count_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_filmstrip_frame_count_help(inputs)
	return en_options_editor_filmstrip_frame_count_help(inputs)
});